export default {
    company_agency: "Comercio",
    my_score: " Mis BitCORs",
    no_company_agency_found: "No se encontraron tiendas",
    "points,": "BitCOR",
    price: "BitCOR",
    project_name: "Academia Coral",
    score: "BitCOR"
}